module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.userAuthenticated && _vm.userSignature && _vm.getDemoEvent) ? _c('div', {
    staticClass: "tone-talk"
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": "joining event"
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.getDemoEvent.jwRtmpUrl) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-7"
  }, [_c('h3', [_vm._v("discussion")]), _vm._v(" "), (_vm.userSignature) ? _c('div', [_c('iframe', {
    attrs: {
      "title": "Live event chat",
      "width": "100%",
      "height": "650",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "allowtransparency": "true",
      "src": _vm.chatRollURL
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-pink",
    on: {
      "click": _vm.leaveEvent
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Leave")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-5"
  }, [_c('h3', [_vm._v("moderator")]), _vm._v(" "), (_vm.getExpert) ? _c('div', {
    staticClass: "moderatorContent"
  }, [_c('img', {
    staticClass: "userImg",
    attrs: {
      "src": _vm.getExpert[0].small_image,
      "alt": _vm.getExpert[0].name,
      "title": _vm.getExpert[0].name
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.getExpert[0].name))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.getExpert[0].expertise))]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.getDemoEvent.longDescription) + "\n                    ")])]) : _vm._e()])])]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "rowtight"
  }, [_c('div', {
    staticClass: "col-sm-8 innerpadding"
  }, [(_vm.getDemoEvent) ? _c('div', {
    staticClass: "embed-responsive embed-responsive-16by9"
  }, [_c('iframe', {
    staticClass: "embed-responsive-item",
    attrs: {
      "title": "TONE video player",
      "src": _vm.getDemoEvent.jwRtmpUrl,
      "frameborder": "0",
      "scrolling": "auto",
      "allowfullscreen": ""
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-left"
  }, [(_vm.userSignature) ? _c('div', [_c('h4', [_vm._v("TONE Topic: " + _vm._s(_vm.getDemoEvent.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDemoEvent.jwStreamTitle))]), _vm._v(" "), _c('h6', [_vm._v("Total Participants: 1")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "title": "Live event chat",
      "width": "100%",
      "height": "280px",
      "frameborder": "0",
      "scrolling": "no",
      "marginheight": "0",
      "marginwidth": "0",
      "allowtransparency": "true",
      "src": _vm.chatRollURL
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn-pink",
    on: {
      "click": _vm.leaveEvent
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Leave")])]) : _vm._e()])]), _vm._v(" "), _vm._m(1)])], 1) : _c('div', [(_vm.getDemoEvent) ? _c('div', {
    staticClass: "community-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/community-icon.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticStyle: {
      "text-transform": "none"
    }
  }, [_vm._v("Join the Conversation at "), (_vm.getDemoEvent.type === '1') ? _c('span', [_vm._v("TONE Live")]) : _c('span', [_vm._v("TONE Talk")])]), _vm._v(" "), (_vm.getDemoEvent) ? _c('div', {
    staticClass: "communityBox"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.getExpert) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [(_vm.currentVideo) ? _c('jwplayer', {
    attrs: {
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")]) : _vm._e(), _vm._v(" "), (!_vm.currentVideo) ? _c('img', {
    attrs: {
      "src": _vm.getDemoEvent.imgUrl,
      "alt": ""
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.getExpert) ? _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6"
  }, [_c('h2', [_vm._v(_vm._s(_vm.getDemoEvent.title) + " with " + _vm._s(_vm.getExpert[0].name))]), _vm._v(" "), (_vm.getExpert[0]) ? _c('p', [_vm._v("\n                            " + _vm._s(_vm.getDemoEvent.longDescription) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.getDateReference(_vm.getDemoEvent.startDate, 'str')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    attrs: {
      "title": "Add to Calendar"
    }
  }, [_vm._v("\n                            Add to Calendar\n                            "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.getDemoEvent.startDate))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getDemoEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.getDemoEvent.longDescription))])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [_c('div', [_c('h3', [_vm._v("Choose how you want to join the event. You can join as yourself or step into someone else's shoes using our anonymous shoe-cognito mode")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "title": "Join event"
    },
    on: {
      "click": function($event) {
        return _vm.switchEventView()
      }
    }
  }, [_vm._v("Gemma")]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button",
      "title": "Join event"
    },
    on: {
      "click": function($event) {
        return _vm.switchEventView()
      }
    }
  }, [_vm._v("Shoe-Incognito")]), _vm._v(" "), _vm._m(2)])])]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_vm._v("Hey, Great to see you. "), _c('br'), _vm._v("Enjoy the Tone Talk!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-7"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n                            Please follow the event guidelines:\n                            "), _c('span', [_vm._v("1.)")]), _vm._v(" Keep it positive, supportive and respectful;\n                            "), _c('span', [_vm._v("2.)")]), _vm._v(" Please be thoughtful and stay on topic;\n                            "), _c('span', [_vm._v("3.)")]), _vm._v(" Please do not post copyrighted material, ads, solicitations or anyone's personal info including your own;\n                            "), _c('span', [_vm._v("4.)")]), _vm._v(" Please refer to TONE's "), _c('a', {
    attrs: {
      "href": "/terms",
      "target": "new",
      "title": "click to view our terms"
    }
  }, [_vm._v("Terms of Service")]), _vm._v(" for more information.\n                        ")])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c0128b10", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c0128b10"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/DemoEvent.vue